(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-dry-food-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-dry-food-filters')) customElements.define('pp-dry-food-filters', class extends HTMLElement {
 connectedCallback() {
  if (this.bound) return;
  this.bound = true;
  const navigate = clear => {
   const url = new URL(location.href);
   const existing = url.pathname.split('/').slice(3).join('/').split('+').filter(Boolean);
   const keep = existing.filter(t => !/^pp-(hypoallergenic|grain-free|potato-free|meat-)/.test(t));
   if (!clear) {
    const data = new FormData(this.querySelector('form'));
    keep.push(...data.getAll('diet'));
    if (data.get('meat')) keep.push(data.get('meat'));
   }
   url.pathname = this.dataset.base + (keep.length ? '/' + [...new Set(keep)].join('+') : '');
   url.searchParams.delete('page');
   location.assign(url.pathname + url.search);
  };
  this.querySelector('form').addEventListener('submit', event => {event.preventDefault();navigate(false);});
  this.querySelector('[data-clear-food-filters]').addEventListener('click', () => navigate(true));
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-infinite-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-infinite-controls')) {
 customElements.define('pp-infinite-controls', class extends HTMLElement {
  connectedCallback() {
   this.frame = requestAnimationFrame(() => this.start());
  }
  disconnectedCallback() {
   cancelAnimationFrame(this.frame);
   this.observer?.disconnect();
   this.controller?.abort();
   this.retry?.removeEventListener('click', this.onRetry);
   this.container?.removeAttribute('data-pp-infinite-ready');
  }
  start() {
   if (!this.isConnected || !('IntersectionObserver' in window)) return;
   this.container = this.closest('#ProductGridContainer');
   this.grid = this.container?.querySelector('[data-scroll-grid]');
   if (!this.grid) return;
   this.status = this.querySelector('[data-scroll-status]');
   this.retry = this.querySelector('[data-scroll-retry]');
   this.next = this.dataset.next;
   this.queue = [];
   this.seen = new Set();
   this.visited = new Set();
   this.loading = false;
   this.failed = false;
   const cards = Array.from(this.grid.children);
   cards.forEach((card, index) => {
    this.seen.add(card.dataset.productId);
    if (index >= 24) {
     card.remove();
     this.queue.push(card);
    }
   });
   this.container.setAttribute('data-pp-infinite-ready', '');
   this.onRetry = () => { this.failed = false; this.load(); };
   this.retry.addEventListener('click', this.onRetry);
   this.observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) this.load();
   }, {rootMargin:'800px 0px'});
   if (this.next || this.queue.length) this.observer.observe(this);
  }
  async fetchPage() {
   const url = new URL(this.next, location.origin);
   if (url.origin !== location.origin || this.visited.has(url.href)) throw new Error('Invalid next page');
   const pageKey = url.href;
   url.searchParams.set('section_id', this.dataset.section);
   const response = await fetch(url, {signal:this.controller.signal, headers:{'X-Requested-With':'XMLHttpRequest'}});
   if (!response.ok) throw new Error('Page request failed');
   const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
   const grid = parsed.querySelector('[data-scroll-grid]');
   const controls = parsed.querySelector('pp-infinite-controls');
   if (!grid || !controls) throw new Error('Incomplete product list');
   this.visited.add(pageKey);
   for (const card of Array.from(grid.children)) {
    const id = card.dataset.productId;
    if (!id) throw new Error('Missing product identity');
    if (this.seen.has(id)) continue;
    this.seen.add(id);
    card.querySelectorAll('script').forEach(script => script.remove());
    this.queue.push(card);
   }
   this.next = controls.dataset.next;
  }
  async load() {
   if (!this.isConnected || this.loading || this.failed || (!this.queue.length && !this.next)) return;
   this.loading = true;
   this.controller = new AbortController();
   this.retry.hidden = true;
   this.status.textContent = this.dataset.loading;
   this.setAttribute('aria-busy', 'true');
   try {
    if (!this.queue.length && this.next) await this.fetchPage();
    if (!this.isConnected) return;
    const cards = this.queue.splice(0, 24);
    for (let offset = 0; offset < cards.length; offset += 4) {
     await new Promise(resolve => setTimeout(resolve, 0));
     if (!this.isConnected || this.controller.signal.aborted) return;
     const batch = cards.slice(offset, offset + 4);
     const fragment = document.createDocumentFragment();
     batch.forEach(card => fragment.appendChild(card));
     this.grid.appendChild(fragment);
     batch.forEach(card => window.PupPlanetDogHelper?.refresh?.(card));
    }
    document.dispatchEvent(new CustomEvent('pp:products-added', {detail:{count:cards.length, grid:this.grid}}));
    if (!this.queue.length && !this.next) {
     this.status.textContent = this.dataset.done;
     this.observer.disconnect();
    } else {
     this.status.textContent = '';
    }
   } catch (error) {
    if (error.name !== 'AbortError' && this.isConnected) {
     this.failed = true;
     this.status.textContent = this.dataset.error;
     this.retry.hidden = false;
    }
   } finally {
    this.loading = false;
    this.removeAttribute('aria-busy');
    if (this.isConnected && !this.failed && (this.queue.length || this.next)) {
     this.frame = requestAnimationFrame(() => {
      const bounds = this.getBoundingClientRect();
      if (bounds.top < innerHeight + 800 && bounds.bottom > -800) this.load();
     });
    }
   }
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
